import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Form, Modal, Select } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import CustomerContactResource from "./api/CustomerContactResource";
const CustomerUserInviteModal = ({ open, customerId, customerContact, onSuccess, onCancel }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        if (customerContact?.userAccess) {
            form.setFieldsValue({
                "showPickupDockets": customerContact.userAccess.showPickupDockets || false,
            });
        }
        else {
            form.resetFields();
        }
    }, [open]);
    const onFinish = (formValues) => {
        setNetworkRequestInProgress(true);
        const request = {
            showPickupDockets: formValues.showPickupDockets
        };
        CustomerContactResource.inviteCustomerContact(customerId, customerContact.id, request, onSuccess, axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    return (_jsx(Modal, { title: "Email Customer Portal Invite", open: open, onOk: form.submit, onCancel: onCancel, confirmLoading: networkRequestInProgress, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [_jsxs("h2", { children: [customerContact?.firstName, " ", customerContact?.lastName] }), _jsxs("h4", { children: ["Email: ", _jsx("strong", { children: customerContact?.emailAddress })] }), _jsx(Form.Item, { name: "showPickupDockets", label: "Can view quarry dockets?", initialValue: false, children: _jsx(Select, { options: [
                            { value: true, label: 'Yes - Show pickup dockets to this user' },
                            { value: false, label: 'No - Hide pickup dockets from this user' }
                        ] }) })] }) }));
};
export default CustomerUserInviteModal;
